import { ReactNode } from "react";
import styles from "./BannerCard.module.scss";

export type BannerCardProps = {
  /** Texte affiché dans le bandeau */
  title: string;
  /** Contenu optionnel à droite du bandeau (navigation, badge, etc.) */
  bannerRight?: ReactNode;
  /** Contenu principal de la card */
  children: ReactNode;
  /** Contenu affiché sous le body, hors du padding (actions, footer) */
  footer?: ReactNode;
};

export function BannerCard({
  title,
  bannerRight,
  children,
  footer,
}: BannerCardProps) {
  return (
    <div className={styles.card}>
      <div className={styles.banner}>
        <h4 className={styles.bannerTitle}>{title}</h4>
        {bannerRight}
      </div>
      <div className={styles.body}>{children}</div>
      {footer}
    </div>
  );
}
